import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl} from '@angular/forms';
import { EmpresasService } from '../../../services/empresas/empresas.service';
import { SafeUrlPipe } from '../../../pipes/safe-url.pipe';
import {HttpErrorResponse } from '@angular/common/http';
import { MessagesTitles, MessagesGeneral, MessagesStatus } from '../../../models/messages';

declare var $: any;
@Component({
  selector: 'app-adjuntar-archivo-contacto',
  templateUrl: './adjuntar-archivo-contacto.component.html',
  styleUrls: ['./adjuntar-archivo-contacto.component.scss'],
  providers:[
    SafeUrlPipe,MessagesTitles,MessagesGeneral,MessagesStatus 
  ]
})

export class AdjuntarArchivoContactoComponent implements OnInit {

  @Input() Fcontacto : any;
  @Input() tipoAdjunto : string;
  @Output() cerrarVentanaAdjunto: EventEmitter<boolean>;
  formAdjunto : FormGroup;
  loading :boolean;
  loadingDni : boolean;
  save :boolean;
  urlVigencia : any;
  urlDni : any;
  error_upload:boolean;
  disableClose :boolean;
  saveVigencia : boolean = true;
  saveDni : boolean = true;
  link : any;
  linkDNI : any;
  user:any;
  errorArchivo : boolean;
  mensajeAdjunto : string;
  mensajeSuccess : string;
  public archivoEnBase64 : string;
  public archivoEnBase64DNI : string;
  
  constructor(
               private msgStatus:MessagesStatus,
               private empresasService : EmpresasService ) { 
                
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.cerrarVentanaAdjunto = new EventEmitter();
    this.error_upload = false;  
  }

  ngOnInit() {
    this.errorArchivo = false;
    this.save = false;
    this.loading = false;
    this.loadingDni = false;
    this.formAdjunto = new FormGroup({
      'idContacto' : new FormControl(''),
      'TipoAdjunto' : new FormControl(''),
      'file_content' : new FormControl(''),
      'Usuario' : new FormControl('')
    })
    this.urlVigencia = this.Fcontacto.Adjunto_Vigencia_Poder;
    this.urlDni = this.Fcontacto.Adjunto_DNI;
  }

  CerrarVentana(){
    this.cerrarVentanaAdjunto.emit();
  }

  onClickVigencia(){
    const fileUpload = document.getElementById('fileUpload') as HTMLInputElement;
    fileUpload.onchange = () => {
      this.aBinario(fileUpload.files)
      this.saveVigencia = false;
    };
  fileUpload.click();
  }

  onClickDni(){
    const fileUpload2 = document.getElementById('fileUpload2') as HTMLInputElement;
    fileUpload2.onchange = () => {
      this.aBinario2(fileUpload2.files)
      this.saveDni = false;
    };
    fileUpload2.click();
  }

  aBinario(fileList: FileList){
    
    let file = fileList[0];
    if ( file.type != 'application/pdf'){        
      this.error_upload = true;
      this.showNotification('warning','top','right','Solo se permite tipo PDF');
     return;
    }
    this.urlVigencia = file.name;
    let fileReader: FileReader = new FileReader();
    var base64;
    var archivo64;
    var self = this;
    fileReader.onload =  function(fileLoadedEvent) {
              base64 = fileLoadedEvent.target['result'];
              archivo64 = base64.split(',',2);
              self.error_upload = false;
              self.archivoEnBase64 = archivo64[1];
           };
        fileReader.readAsDataURL(file);
  }

  aBinario2(fileList: FileList){
    let file = fileList[0];
    if ( file.type != 'application/pdf'){        
      this.error_upload = true;
      this.showNotification('warning','top','right','Solo se permite tipo PDF');
      return;
    }
    
    this.urlDni = file.name;
    let fileReader: FileReader = new FileReader();
    var base64;
    var archivo64;
    var self = this;
    fileReader.onload =  function(fileLoadedEvent) {
              base64 = fileLoadedEvent.target['result'];
              archivo64 = base64.split(',',2);
              self.error_upload = false;
              self.archivoEnBase64DNI = archivo64[1];
           };
        fileReader.readAsDataURL(file);
  }

  GuardarVigencia(){

    if (this.archivoEnBase64 != null ){
      this.loading = true;
      this.disableClose = true;  
      this.formAdjunto.controls['idContacto'].setValue(this.Fcontacto['idContacto']);
      this.formAdjunto.controls['TipoAdjunto'].setValue(this.tipoAdjunto);
      this.formAdjunto.controls['file_content'].setValue( (this.archivoEnBase64 == null ) ? '' : this.archivoEnBase64);
      this.formAdjunto.controls['Usuario'].setValue(this.user.Usuario);
      
      this.empresasService.agregarAdjunto(this.formAdjunto.getRawValue())
            .subscribe( resp => {
              this.urlVigencia = resp['message'];
              this.loading = false;
              this.disableClose = false;
              this.saveVigencia = true;
              this.showNotification('success','top','right','Vigencia guardada con éxito');
              this.save = true;           
            },(err: HttpErrorResponse)=> {
              this.loading = false;
              this.disableClose = false;
              if (err.error instanceof ErrorEvent) {
                console.error("Error Event");
            } else {
                this.msgStatus.getMessage(err.status);            
            }
            this.showNotification('danger','top','right','Hubo un error. '+this.msgStatus.message);
            })
    }
  }

  GuardarDNI(){
   
    if(this.archivoEnBase64DNI  != null){
      this.loadingDni = true;
      this.disableClose = true;
      this.formAdjunto.controls['idContacto'].setValue(this.Fcontacto['idContacto']);
      this.formAdjunto.controls['TipoAdjunto'].setValue(this.tipoAdjunto);
      this.formAdjunto.controls['file_content'].setValue( (this.archivoEnBase64DNI == null ) ? '' : this.archivoEnBase64DNI);
      this.formAdjunto.controls['Usuario'].setValue(this.user.Usuario);
  
      this.empresasService.agregarAdjuntoDNI(this.formAdjunto.getRawValue())
            .subscribe( resp => {
              this.urlDni = resp['message'];
              this.loadingDni = false;
              this.disableClose = false;
              this.saveDni = true;
              this.showNotification('success','top','right','DNI guardado con éxito');            
            },(err: HttpErrorResponse)=> {
              this.loadingDni = false;
              this.disableClose = false;
              if (err.error instanceof ErrorEvent) {
                console.error("Error Event");
            } else {
                this.msgStatus.getMessage(err.status);            
            }
            this.showNotification('danger','top','right','DNI NO GUARDADO. '+this.msgStatus.message);
            })
    }
  }
    
  showNotification(type,from,align,message){
  
    $.notify({
        icon: "notifications",
        message: message
    },{
        type: type,
        timer: 4000,
        placement: {
            from: from,
            align: align
        },
        template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
          '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
          '<i class="material-icons" data-notify="icon">notifications</i> ' +
          '<span data-notify="title">{1}</span> ' +
          '<span data-notify="message">{2}</span>' +
          '<div class="progress" data-notify="progressbar">' +
            '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
          '</div>' +
          '<a href="{3}" target="{4}" data-notify="url"></a>' +
        '</div>'
    });
  }  

}
